const contractAddr = '0x28252e35FbB1dC737f0d9B13857f572A88B142a9'
const contractChainId = 31337
const maxTokensPerSale = 10
const tokensSalePrice = 0.09
const tokensPresalePrice = 0.05
const totalTokens = 3888
const defaultMetadataUri = './static/bayc-metadata.json'
const marketplaceCollectionUri = 'https://opensea.io/assets/theqbits'
const fetchEthPriceUri = 'https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd'
const ipfsNftGatewayUri = ipfsHash => ('https://gateway.pinata.cloud/ipfs/' + ipfsHash)
const ipfsWebGatewayUri = ipfsHash => ('https://ipfs.io/ipfs/' + ipfsHash)
const explorerAddressUri = addr => ('https://etherscan.io/address/' + addr)
const explorerContractUri = contractAddr => ('https://etherscan.io/address/' + contractAddr + '#readContract')
const explorerTokenUri = (contractAddr, tokenId) => ('https://etherscan.io/token/' + contractAddr + '?a=' + tokenId + '#inventory')
const marketplaceTokenUri = (contractAddr, tokenId) => ('https://opensea.io/assets/' + contractAddr + '/' + String(tokenId))
const fetchHRContentUri = (tokenId, signature) => ('https://n96g1mje14.execute-api.us-east-1.amazonaws.com/dev/hr-content?tokenId=' + String(tokenId) + '&signature=' + signature)
const fetchNftMetadataUri = (contractAddr, tokenId) => ('https://testnets-api.opensea.io/api/v1/asset/0xD4B2FE0343F8169c43ECd312356F93c1538A51Fb/' + String(tokenId) || contractAddr)
const revealHRContentMsg = (tokenId) => ('Reveal high resolution content for QBIT # ' + String(tokenId))

export default {
  contractAddr,
  contractChainId,
  maxTokensPerSale,
  tokensSalePrice,
  tokensPresalePrice,
  totalTokens,
  defaultMetadataUri,
  marketplaceCollectionUri,
  fetchEthPriceUri,
  ipfsNftGatewayUri,
  ipfsWebGatewayUri,
  explorerAddressUri,
  explorerContractUri,
  explorerTokenUri,
  marketplaceTokenUri,
  fetchHRContentUri,
  fetchNftMetadataUri,
  revealHRContentMsg
}
export {
  contractAddr,
  contractChainId,
  maxTokensPerSale,
  tokensSalePrice,
  tokensPresalePrice,
  totalTokens,
  defaultMetadataUri,
  marketplaceCollectionUri,
  fetchEthPriceUri,
  ipfsNftGatewayUri,
  ipfsWebGatewayUri,
  explorerAddressUri,
  explorerContractUri,
  explorerTokenUri,
  marketplaceTokenUri,
  fetchHRContentUri,
  fetchNftMetadataUri,
  revealHRContentMsg
}
